import React, { createContext, useState, useContext, useRef, useEffect } from 'react'
import { OrderEngineContext } from './OrderEngineContext'
import axios from 'axios'
import okeResponse from 'okeoke.standardresponse'
import SocketIOClient from 'socket.io-client'

const OkeMessagingContext = createContext()

const messagingUrl = 'https://messaging.app.okeoke.io'
const messagingUrlDev = 'https://messaging.app.okeoke.io'

const OkeMessagingProvider = (props) => {
  const { brandID, token, apiUrl } = useContext(OrderEngineContext)
  const tokenRef = useRef(null)
  const brandIDRef = useRef(null)
  const ioRef = useRef(null)
  const [messagingConnected, setMessagingConnected] = useState(false)
  const [messagingLoggedIn, setMessagingLoggedIn] = useState(false)
  const [messagingParams, setMessagingParams] = useState({})

  const messagingUrlRef = useRef(messagingUrlDev)

  const [articles, setArticles] = useState([])

  const getMessagingParams = async (_brandID) => {
    try {
      const response = await axios(messagingUrlRef.current +  '/api/v2/params', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'brandid': _brandID,
        }
      })
      if(response.data.success) {
        setMessagingParams(response.data.data?.params || {})
      }
      return response.data
    } catch (e) {
      return okeResponse(false, 500, 'Internal error.', e)
    }
  }

  const getArticles = async () => {
    try {
      if(!messagingParams) return okeResponse(false, 500, 'Messaging not available.', null)
      const response = await axios(messagingUrlRef.current +  '/api/v2/customer/newsfeed', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + tokenRef.current,
          'brandid': brandIDRef.current,
        }
      })
      if(response.data.success) setArticles(response.data.data || [])
      return response.data
    } catch (e) {
      return okeResponse(false, 500, 'Internal error.', e)
    }
  }

  const setArticleAction = async (articleUID, action, active = 1) => {
    try {
      if(!messagingParams) return okeResponse(false, 500, 'Messaging not available.', null)
      const response = await axios(messagingUrlRef.current +  '/api/v2/customer/newsfeed', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + tokenRef.current,
          'brandid': brandIDRef.current,
        },
        data: JSON.stringify({ 
          articleUID,
          action,
          active
        }),
      })
      let result = response.data
      if(result.success) getArticles()
      return result
    } catch (e) {
      return okeResponse(false, 500, 'Internal error.', e)
    }
  }

  const onConnectionChange = (data) => {
    switch (data.state) {
      case 'Connected': {
        setMessagingConnected(true)
        getArticles()
      }
        break
      case 'Disconnected': {
        setMessagingConnected(false)
        setMessagingLoggedIn(false)
      }
        break
    }
  }

  useEffect(() => {
    if(brandID) getMessagingParams(brandID)
  }, [brandID])

  useEffect(() => {
    tokenRef.current = token
    brandIDRef.current = brandID
  }, [brandID, token])

  useEffect(() => {
    if (!ioRef.current && token && brandID && messagingParams) {
      let ioClient = SocketIOClient(messagingUrlRef.current, {
        path: '/msg.sock',
        transports: ['websocket'],
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        reconnectionAttempts: 0
      })
      ioClient.on('connect', () => {
        ioClient.emit('login', {
          brandID: brandID,
          token: token,
          type: 'customer',
        }, (data) => {
          //console.log('login res:', data)
          if(data.success) {
            ioClient.emit('ready', { }, (data) => {
              //console.log('ready res:', data)
            })
            setMessagingLoggedIn(true)
          }
        })
        onConnectionChange({ state: 'Connected', message: '' })
      })
      ioClient.on('disconnect', () => {
        onConnectionChange({ state: 'Disconnected', message: '' })
      })
      ioClient.on('error', (error) => {
        onConnectionChange({ state: 'Disconnected', message: error })
      })
      ioClient.on('reconnect', () => {
      })
      ioRef.current = ioClient
    }
  }, [token, brandID, messagingParams])

  return (
    <OkeMessagingContext.Provider
      value={{
        setArticleAction,
        messagingConnected,
        messagingLoggedIn,
        articles
      }}
    >
      {props.children}
    </OkeMessagingContext.Provider>
  )
}

export { OkeMessagingContext, OkeMessagingProvider }
